(function () {
  'use strict';

  var PERSONALISE_SELECTORS = [
    '#openPersonalizationModal',
    '[data-open-personalization-modal]',
    '.btn-personalize-product',
    '.product-form__buy-buttons .pplr-btn',
    '.product-form__buy-buttons button.pplr-c-button',
    '.product-personalizer .pplr-btn',
    '.product-personalizer button.pplr-c-button',
    '.product-personalizer button.btn',
    '.troopod_atc'
  ];

  function getMoneyFormat() {
    var sticky = document.querySelector('[data-rabitat-sticky-cart]');
    if (sticky && sticky.dataset.moneyFormat) {
      return sticky.dataset.moneyFormat;
    }

    return '${{amount}}';
  }

  function formatVariantMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, getMoneyFormat());
    }

    return (cents / 100).toFixed(2);
  }

  function getSoldOutLabel() {
    var btn = document.querySelector('[data-rabitat-sticky-cart] [data-product-add-to-cart-button]');
    if (btn) {
      var mainBtn = document.querySelector('.rabitat-product-page__add-btn');
      if (mainBtn && mainBtn.getAttribute('data-sold-out-label')) {
        return mainBtn.getAttribute('data-sold-out-label');
      }
    }

    return 'Sold out';
  }

  function findPersonalisationTrigger() {
    var i;
    var el;

    for (i = 0; i < PERSONALISE_SELECTORS.length; i++) {
      el = document.querySelector(PERSONALISE_SELECTORS[i]);
      if (el) return el;
    }

    var customizeBtn = document.querySelector('.rabitat-product-page__customize[data-open-personalization-modal]');
    if (customizeBtn) return customizeBtn;

    return null;
  }

  function openPersonalisationPopup(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var trigger = findPersonalisationTrigger();
    if (trigger) {
      trigger.click();
      return;
    }

    if (window.PersonalizationModal && typeof window.PersonalizationModal.open === 'function') {
      window.PersonalizationModal.open();
    }
  }

  function updateStickyPrices(variant) {
    if (!variant) return;

    var priceEls = document.querySelectorAll('[data-sticky-price]');
    priceEls.forEach(function (el) {
      if (variant.price_formatted) {
        el.textContent = variant.price_formatted;
      } else {
        el.textContent = formatVariantMoney(variant.price);
      }
    });

    var comparePriceEl = document.querySelector('[data-sticky-compare-price]');
    var discountEl = document.querySelector('[data-sticky-discount]');

    if (comparePriceEl && discountEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = variant.compare_formatted || formatVariantMoney(variant.compare_at_price);
        comparePriceEl.hidden = false;

        var discountPct = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );
        discountEl.textContent = discountPct + '% Off';
        discountEl.hidden = false;
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.hidden = true;
        discountEl.textContent = '';
        discountEl.hidden = true;
      }
    }

    var stickyButtons = document.querySelectorAll('.rabitat-sticky-cart [data-product-add-to-cart-button]');
    stickyButtons.forEach(function (button) {
      button.disabled = !variant.available;

      var defaultLabel = button.getAttribute('data-button-content') || button.getAttribute('data-default-label');
      var hydeStickyLabel = button.querySelector('[data-hyde-sticky-add-label]');
      var hydeStickyPrice = button.querySelector('[data-hyde-sticky-atc-price]');
      var hydeStickyBadge = document.querySelector('[data-hyde-sticky-customisable-badge]');

      if (variant.available) {
        if (hydeStickyLabel) {
          if (defaultLabel) hydeStickyLabel.textContent = defaultLabel;
        } else if (defaultLabel) {
          button.textContent = defaultLabel;
        }
        if (hydeStickyPrice) hydeStickyPrice.hidden = false;
        if (hydeStickyBadge) hydeStickyBadge.hidden = false;
      } else if (hydeStickyLabel) {
        hydeStickyLabel.textContent = getSoldOutLabel();
        if (hydeStickyPrice) hydeStickyPrice.hidden = true;
        if (hydeStickyBadge) hydeStickyBadge.hidden = true;
      } else {
        button.textContent = getSoldOutLabel();
        if (hydeStickyPrice) hydeStickyPrice.hidden = true;
        if (hydeStickyBadge) hydeStickyBadge.hidden = true;
      }
    });
  }

  function initStickyPersonalise() {
    document.addEventListener('click', function (event) {
      if (
        event.target.closest('.rabitat-sticky-cart__personalise-banner') ||
        event.target.closest('.product-sticky-form__desktop-personalise')
      ) {
        openPersonalisationPopup(event);
      }
    });
  }

  function findHydeAtcTarget() {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      return document.querySelector(
        '.hyde-pdp__add-btn--mobile, .hyde-pdp__actions-mobile .rabitat-product-page__add-btn, .rabitat-product-page__add-btn'
      );
    }

    return document.querySelector(
      '.hyde-pdp__add-btn--desktop, .hyde-pdp__actions-desktop .rabitat-product-page__add-btn, [data-product-actions]'
    );
  }

  function setupStickyVisibility() {
    var sticky = document.querySelector('[data-rabitat-sticky-cart]');
    if (!sticky) return;

    if (sticky._rabitatVisibilityObserver) {
      sticky._rabitatVisibilityObserver.disconnect();
    }

    var requireScrollPastAtc = document.body.classList.contains('template-product-hyde-cro');
    var atcTarget = requireScrollPastAtc
      ? findHydeAtcTarget()
      : document.querySelector('[data-product-actions]');
    var footer = document.querySelector('.rabitat-footer');

    if (!atcTarget) return;

    var atcVisible = false;
    var atcScrolledPast = false;
    var footerVisible = false;

    function updateVisibility() {
      if (requireScrollPastAtc) {
        sticky.hidden = !atcScrolledPast || footerVisible;
        return;
      }

      sticky.hidden = atcVisible || footerVisible;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === atcTarget) {
            atcVisible = entry.isIntersecting;

            if (requireScrollPastAtc) {
              atcScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            }
          }
          if (footer && entry.target === footer) {
            footerVisible = entry.isIntersecting;
          }
        });
        updateVisibility();
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -10px 0px'
      }
    );

    observer.observe(atcTarget);
    if (footer) observer.observe(footer);

    sticky._rabitatVisibilityObserver = observer;

    requestAnimationFrame(updateVisibility);
  }

  function init() {
    initStickyPersonalise();
    setupStickyVisibility();
    setTimeout(setupStickyVisibility, 100);
    window.addEventListener('resize', setupStickyVisibility);
  }

  document.addEventListener('rabitat:variant:changed', function (event) {
    updateStickyPrices(event.detail && event.detail.variant);
  });

  document.addEventListener('variant:changed', function (event) {
    updateStickyPrices(event.detail && event.detail.variant);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
